export default "__VITE_ASSET__BzOrTenX__"